/* ============================================================================
   MYO STORE — "MILANO 1981" : capa de interacción
   Una sola cosa: la cabecera gana sombra dura cuando la página se mueve.
   Sin observadores de scroll que puedan dejar contenido invisible.
   ========================================================================== */
(() => {
  const header = document.querySelector('.section-header');
  if (!header) return;

  let ticking = false;

  const sync = () => {
    header.classList.toggle('mi-scrolled', window.scrollY > 24);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(sync);
    }
  }, { passive: true });

  sync();
})();
